"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.response = exports.notImplementedResponse = exports.internalServerError = exports.invalidBodyFieldResponse = exports.missingBodyFieldResponse = exports.unprocessableEntityResponse = exports.conflictResponse = exports.notFoundResponse = exports.forbiddenResponse = exports.unauthResponse = exports.invalidParameterResponse = exports.missingParameterResponse = exports.badRequestResponse = exports.foundResponse = exports.noContentResponse = exports.createdResponse = exports.batchSuccessResponse = exports.successResponse = void 0;
const BaseStoreUnit_1 = require("../models/BaseStoreUnit");
function parse(obj) {
    if (obj instanceof BaseStoreUnit_1.BaseStoreUnit) {
        return obj.toView();
    }
    return obj;
}
/**
 * Assembles a 200 SUCCESS response for a single StoreUnit or any object.
 *  - If the body is an instance of a `BaseStoreUnit` this function will run `.toView` for you.
 */
function successResponse(requestOrCorrelationId, body) {
    return response(200, requestOrCorrelationId, parse(body));
}
exports.successResponse = successResponse;
/**
 * Assembles a 200 SUCCESS response for an array of StoreUnits or objects.
 *  - If the items contains instances of `BaseStoreUnit`s this function will run `.toView` on them for you.
 */
function batchSuccessResponse(requestOrCorrelationId, items, lastKey) {
    const body = {
        items: items.map(parse),
        count: items.length
    };
    if (lastKey) {
        body.lastKey = lastKey;
    }
    return response(200, requestOrCorrelationId, body);
}
exports.batchSuccessResponse = batchSuccessResponse;
/**
 * Assembles a 201 CREATED response for a single StoreUnit or any object.
 *  - If the body is an instance of a `BaseStoreUnit` this function will run `.toView` for you.
 */
function createdResponse(requestOrCorrelationId, body) {
    return response(201, requestOrCorrelationId, parse(body));
}
exports.createdResponse = createdResponse;
function noContentResponse(requestOrCorrelationId) {
    return response(204, requestOrCorrelationId);
}
exports.noContentResponse = noContentResponse;
function foundResponse(requestOrCorrelationId, headers) {
    return response(302, requestOrCorrelationId, undefined, headers);
}
exports.foundResponse = foundResponse;
function badRequestResponse(requestOrCorrelationId, reason, pointer) {
    const body = {};
    if (reason) {
        body.reason = reason;
    }
    if (pointer) {
        body.pointer = pointer;
    }
    return response(400, requestOrCorrelationId, body);
}
exports.badRequestResponse = badRequestResponse;
function missingParameterResponse(requestOrCorrelationId, parameter) {
    return badRequestResponse(requestOrCorrelationId, `missing ${parameter}`, parameter);
}
exports.missingParameterResponse = missingParameterResponse;
function invalidParameterResponse(requestOrCorrelationId, parameter) {
    return badRequestResponse(requestOrCorrelationId, `invalid ${parameter}`, parameter);
}
exports.invalidParameterResponse = invalidParameterResponse;
function unauthResponse(requestOrCorrelationId, reason = 'Invalid or missing access-key') {
    return response(401, requestOrCorrelationId, {
        reason
    });
}
exports.unauthResponse = unauthResponse;
function forbiddenResponse(requestOrCorrelationId, reason, meta) {
    const body = {};
    if (reason) {
        body.reason = reason;
    }
    if (meta) {
        body.meta = meta;
    }
    return response(403, requestOrCorrelationId, Object.keys(body).length ? body : undefined);
}
exports.forbiddenResponse = forbiddenResponse;
function notFoundResponse(requestOrCorrelationId, body) {
    return response(404, requestOrCorrelationId, body);
}
exports.notFoundResponse = notFoundResponse;
function conflictResponse(requestOrCorrelationId, body) {
    return response(409, requestOrCorrelationId, body);
}
exports.conflictResponse = conflictResponse;
function unprocessableEntityResponse(requestOrCorrelationId, reason, pointer) {
    const body = {};
    if (reason) {
        body.reason = reason;
    }
    if (pointer) {
        body.pointer = pointer;
    }
    return response(422, requestOrCorrelationId, body);
}
exports.unprocessableEntityResponse = unprocessableEntityResponse;
function missingBodyFieldResponse(requestOrCorrelationId, bodyField) {
    return unprocessableEntityResponse(requestOrCorrelationId, `missing field ${bodyField}`, bodyField);
}
exports.missingBodyFieldResponse = missingBodyFieldResponse;
function invalidBodyFieldResponse(requestOrCorrelationId, bodyField) {
    return unprocessableEntityResponse(requestOrCorrelationId, `invalid field ${bodyField}`, bodyField);
}
exports.invalidBodyFieldResponse = invalidBodyFieldResponse;
/**
 * **WARNING** Make sure you're not going to be leaking sensitive information via error messages. I.e do you need to return the error?
 */
function internalServerError(requestOrCorrelationId, error) {
    return response(500, requestOrCorrelationId, error
        ? {
            errorMessage: error.message,
            errorName: error.name
        }
        : {});
}
exports.internalServerError = internalServerError;
function notImplementedResponse(requestOrCorrelationId, body) {
    return response(501, requestOrCorrelationId, body);
}
exports.notImplementedResponse = notImplementedResponse;
function response(statusCode, requestOrCorrelationId, body, headers) {
    const requestCorrelationId = typeof requestOrCorrelationId === 'string'
        ? requestOrCorrelationId
        : requestOrCorrelationId.headers.correlationid;
    const response = {
        statusCode,
        // @ts-ignore: caused by making headers optional here
        headers: {
            ...headers,
            correlationId: requestCorrelationId || `${new Date().getTime()}::autogenCorrelationId`
        }
    };
    if (body) {
        response.body = body;
    }
    return response;
}
exports.response = response;
